/**
 * UX-015: the sidebar used `location.pathname === href`, so a detail route
 * such as /employees/abc highlighted nothing at all — the operator lost their
 * place the moment they opened a record. Prefix matching restores the parent,
 * with "/" handled exactly so Dashboard does not light up on every page.
 *
 * This lives in lib/ rather than in ShellLayout because BottomNav and
 * NavDrawer need it too and importing the shell from them would be circular.
 * The original fix only reached the sidebar, so phone users kept the bug the
 * desktop nav had already had fixed.
 */
export function isNavItemActive(pathname: string, href: string): boolean {
  if (href === '/') return pathname === '/';
  return pathname === href || pathname.startsWith(`${href}/`);
}
